export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const CLEAR_REGISTER = "CLEAR_REGISTER";
export const LOGOUT = "LOGOUT";
export const ShowLoginModal = "ShowLoginModal";
export const HideLoginModal = "HideLoginModal";
export const ShowLogin2Modal = "ShowLogin2Modal";
export const HideLogin2Modal = "HideLogin2Modal";
export const MultipleAdded = "MultipleAdded";
export const MultipleAddedOff = "MultipleAddedOff";
export const CartUpdatedTrue = "CartUpdatedTrue";
export const CartUpdatedFalse = "CartUpdatedFalse";
export const SidePriceUpdate = "SidePriceUpdate";
export const SideDiscountedPrice = "SideDiscountedPrice";